module.exports = __webpack_public_path__ + "static/media/no-villas-found.f76e84ed.svg";